/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Biophysics16Inputs */

const en__field__enum_studyprograms_study_biophysics16 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Biophysics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biophysics`)
};

const de__field__enum_studyprograms_study_biophysics16 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Biophysics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biophysik`)
};

/**
* | output |
* | --- |
* | "Biophysics" |
*
* @param {_Field__Enum_Studyprograms_Study_Biophysics16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_biophysics16 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Biophysics16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Biophysics16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_biophysics16(inputs)
	return de__field__enum_studyprograms_study_biophysics16(inputs)
});
export { _field__enum_studyprograms_study_biophysics16 as "_field__enum_studyPrograms_STUDY_BIOPHYSICS" }